import { useState } from "react";

import MuscleBuildindVideo from "../../assets/videos/mp4/barbelInclineBenchPress.mp4";
import BarbelSplitSquats from "../../assets/videos/mp4/barbelSplitSquats.mp4";
import Burpees from "../../assets/videos/mp4/burpees.mp4";
import WalkOutsWithShoulderTap from "../../assets/videos/mp4/walkOutsWithShoulderTap.mp4";
import CustomButton from "../../components/CustomButton";
import CONSTANTS from "../../utils/constants/CONSTANTS";

import { eventTrack, eventTrackGA4 } from "../../utils/helperFunctions";

import "./index.scss";

const CustomWorkouts = () => {
  const [selectWorkout, setSelectWorkout] = useState(CONSTANTS.muscleBuilding);

  return (
    <div className="custom-workouts">
      <div className="sub-heading">Custom workouts</div>
      <div className="heading">for every goal</div>
      <div className="text">
        Omni-Active® Fitness trainers will analyze your goals, exercise experience and more to develop workouts
        specifically for you
      </div>
      <div className="video-workout">
        {selectWorkout === CONSTANTS.muscleBuilding && (
          <video
            className="video"
            autoPlay="true"
            loop="true"
            muted="true"
            playsinline=""
            data-wf-ignore="true"
            data-object-fit="cover"
          >
            <source src={MuscleBuildindVideo} data-wf-ignore="true" />
          </video>
        )}
        {selectWorkout === CONSTANTS.weightLoss && (
          <video
            className="video"
            autoPlay="true"
            loop="true"
            muted="true"
            playsinline=""
            data-wf-ignore="true"
            data-object-fit="cover"
          >
            <source src={Burpees} data-wf-ignore="true" />
          </video>
        )}
        {selectWorkout === CONSTANTS.generalFitness && (
          <video
            className="video"
            autoPlay="true"
            loop="true"
            muted="true"
            playsinline=""
            data-wf-ignore="true"
            data-object-fit="cover"
          >
            <source src={WalkOutsWithShoulderTap} data-wf-ignore="true" />
          </video>
        )}
        {selectWorkout === CONSTANTS.atheleticPerformance && (
          <video
            className="video"
            autoPlay="true"
            loop="true"
            muted="true"
            playsinline=""
            data-wf-ignore="true"
            data-object-fit="cover"
          >
            <source src={BarbelSplitSquats} data-wf-ignore="true" />
          </video>
        )}
      </div>
      <div className="buttons">
        <div className="btn">
          <CustomButton
            handleClick={() => {
              setSelectWorkout(CONSTANTS.muscleBuilding);
              eventTrack("Watching Video", "Watching muscle building workout video", "watching video");
              eventTrackGA4(
                "Watching muscle building Video",
                "Watching muscle building workout video",
                "watching video"
              );
            }}
            type={`${selectWorkout === CONSTANTS.muscleBuilding ? "btn-selected" : CONSTANTS.GREY_TYPE}`}
          >
            Muscle Building
          </CustomButton>
        </div>
        <div className="btn">
          <CustomButton
            handleClick={() => {
              setSelectWorkout(CONSTANTS.weightLoss);
              eventTrack("Watching Video", "Watching weight loss workout video", "watching video");
              eventTrackGA4("Watching weight loss Video", "Watching weight loss workout video", "watching video");
            }}
            type={`${selectWorkout === CONSTANTS.weightLoss ? "btn-selected" : CONSTANTS.GREY_TYPE}`}
          >
            Weight Loss
          </CustomButton>
        </div>
        <div className="btn">
          <CustomButton
            handleClick={() => {
              setSelectWorkout(CONSTANTS.generalFitness);
              eventTrack("Watching Video", "Watching general fitness workout video", "watching video");
              eventTrackGA4(
                "Watching general fitness Video",
                "Watching general fitness workout video",
                "watching video"
              );
            }}
            type={`${selectWorkout === CONSTANTS.generalFitness ? "btn-selected" : CONSTANTS.GREY_TYPE}`}
          >
            General Fitness
          </CustomButton>
        </div>
        <div className="btn">
          <CustomButton
            handleClick={() => {
              setSelectWorkout(CONSTANTS.atheleticPerformance);
              eventTrack("Watching Video", "Watching athletic performance workout video", "watching video");
            }}
            type={`${selectWorkout === CONSTANTS.atheleticPerformance ? "btn-selected" : CONSTANTS.GREY_TYPE}`}
          >
            Atheletic Performance
          </CustomButton>
        </div>
      </div>
    </div>
  );
};
export default CustomWorkouts;
